/**
 * Account validations
 *
 * Validation schemas for account-related fields:
 * email, phone, verification code, PIN, etc.
 */
import { z } from "zod";
import { t, createValidator } from "./utils";
/**
 * Email validation schema factory
 */
export const emailSchema = () => {
    return z.string().email({ message: t("email.invalid") });
};
const PHONE_REGEX = /^(?:\+1\d{10}|\+52(?:1\d{10}|\d{8,10}))$/;
/**
 * Phone number validation schema factory
 * Validates E.164 format with support for US (+1) and Mexico (+52) numbers
 */
export const phoneSchema = () => {
    return z
        .string()
        .min(1, { message: t("required") })
        .regex(PHONE_REGEX, { message: t("phone.invalid") });
};
/**
 * Verification code validation schema factory
 */
export const verificationCodeSchema = () => {
    return z
        .string()
        .length(5, { message: t("verification.invalid") })
        .regex(/^\d+$/, { message: t("verification.invalid") });
};
/**
 * PIN validation schema factory
 */
export const pinSchema = () => {
    return z
        .string()
        .length(4, { message: t("pin.invalid") })
        .regex(/^\d{4}$/, { message: t("pin.invalid") })
        .optional();
};
// Validator functions
export const validateEmail = createValidator(emailSchema);
export const validatePhone = createValidator(phoneSchema);
export const validateVerificationCode = createValidator(verificationCodeSchema);
export const validatePin = createValidator(pinSchema);
